(function () {
  'use strict';

  function toast(message, isError) {
    var el = document.getElementById('em-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'em-toast';
      el.className = 'em-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }
  window.emToast = toast;

  function refreshBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var inner = doc.querySelector('.shopify-section');
    bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
  }

  // Quick add to cart (plain button, not a cart form), synced with the theme cart drawer and cart bubble
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-em-quick-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    var drawer = document.querySelector('cart-drawer');
    var payload = {
      items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
      sections: drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble',
      sections_url: window.location.pathname
    };

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          throw new Error(r.data.description || r.data.message || btn.dataset.errorText);
        }
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
        var item = r.data.items ? r.data.items[0] : r.data;
        if (drawer && typeof drawer.renderContents === 'function' && r.data.sections && r.data.sections['cart-drawer']) {
          drawer.classList.remove('is-empty');
          try { drawer.renderContents({ id: item && item.id, sections: r.data.sections }); }
          catch (e) { refreshBubble(r.data.sections); toast(btn.dataset.successText); }
        } else {
          refreshBubble(r.data.sections);
          toast(btn.dataset.successText);
        }
      })
      .catch(function (err) {
        toast(err && err.message ? err.message : btn.dataset.errorText, true);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });
})();
